// import * as actions from './resumes.actions'

const initialState = {}

const actionsMap = {}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
